module.exports = __webpack_public_path__ + "img/dhl.005f16a4.png";